//return product button
{
  let return_product = document.querySelectorAll('.js-return-products');
  if (return_product.length > 0) {
    return_product.forEach(return_button => {
     return_button.addEventListener("click", (event) => {
       let targetElement = event.target;
       let anchorLink= targetElement.closest("a");
       let buttonElement = targetElement.closest("button");
       let position;
       let area_privada = "area_privada";
       if (anchorLink || buttonElement || targetElement.tagName === "A" || targetElement.tagName === "BUTTON") {
 
         let buttonUrl = targetElement.getAttribute("data-src") || targetElement.getAttribute("href") || return_button.querySelector("button")?.getAttribute("data-src") ||
         return_button.querySelector("a")?.getAttribute("href") || return_button.closest("a")?.getAttribute("href") || null;
       
         if (targetElement.tagName === "A") {
           elementType = "link";
           buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().replace(/\s+/g, "_")  .toLowerCase();
           buttonUrl = buttonUrl ? buttonUrl : return_button.getAttribute("href");
           actionType = 'click_on_link';
         } else if (targetElement.tagName === "BUTTON") {
           elementType = "button";
           buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().replace(/\s+/g, "_")  .toLowerCase();
           position = targetElement?.dataset.position;
           actionType = 'click_on_button'
         }
         
         window.dataLayer = window.dataLayer || [];
         window.dataLayer.push({
           'event': 'select_content',
           'content_type': area_privada,
           'action_type': actionType,
           'element': elementType,
           'position': position,
           'link_text': buttonText,
           'url_destination': buttonUrl
         });
       }
     })
    });
  }
}

//manage button
{
   let manage_button = document.querySelectorAll('.js-manage-button');  
   if (manage_button.length > 0) {
      manage_button.forEach(manage_buttons => {
      manage_buttons.addEventListener("click", (event) => {
        let targetElement = event.target;
        let anchorLink= targetElement.closest("a");
        let buttonElement = targetElement.closest("button");
        let position;
        let area_privada = "area_privada";
        if (anchorLink || buttonElement || targetElement.tagName === "A" || targetElement.tagName === "BUTTON") {

          let buttonUrl = targetElement.getAttribute("data-url") || targetElement.getAttribute("href") || manage_buttons.querySelector("button")?.getAttribute("data-src") ||
          manage_buttons.querySelector("a")?.getAttribute("href") || manage_buttons.closest("a")?.getAttribute("href") || null;
          buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toLowerCase();
          buttonUrl = buttonUrl ? buttonUrl : manage_buttons.getAttribute("href");
          position = targetElement?.dataset.position || null;
      
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'select_content',
            'content_type': area_privada,
            'action_type': "click_on_button",
            'element': "button",
            'position': position,
            'link_text': buttonText,
            'url_destination': buttonUrl
          });
        }
      })
    });
   }
}

//logout button
{
   let logout_button = document.querySelectorAll('.js-logout-button');
   if (logout_button.length > 0) {
      logout_button.forEach(logout_buttons => {
      logout_buttons.addEventListener("click", (event) => {
        let targetElement = event.target;
        let anchorLink= targetElement.closest("a");
        let buttonElement = targetElement.closest("button");
        let position;
        let area_privada = "area_privada";
        if (anchorLink || buttonElement || targetElement.tagName === "A" || targetElement.tagName === "BUTTON") {

          let buttonUrl = targetElement.getAttribute("data-url") || targetElement.getAttribute("href") || logout_buttons.querySelector("button")?.getAttribute("data-src") ||
          logout_buttons.querySelector("a")?.getAttribute("href") || logout_buttons.closest("a")?.getAttribute("href") || null;
        
          if (targetElement.tagName === "A") {
            elementType = "link";
            buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toLowerCase();
            buttonUrl = buttonUrl ? buttonUrl : logout_buttons.getAttribute("href");
            actionType = 'click_on_link';
            position = targetElement?.dataset.position || null;
          } else if (targetElement.tagName === "BUTTON") {
            elementType = "button";
            buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toLowerCase();
            position = targetElement?.dataset.position || null;
            actionType = 'click_on_button'
          }
        
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'select_content',
            'content_type': area_privada,
            'action_type': actionType,
            'element': elementType,
            'position': position,
            'link_text': buttonText,
            'url_destination': buttonUrl
          });
        }
      })
    });
   }
}

// add address button 
{
   let add_address_button = document.querySelectorAll('.js-add-address-button');
   if (add_address_button.length > 0) {
      add_address_button.forEach(add_address_buttons => {
      add_address_buttons.addEventListener("click", (event) => {
        let targetElement = event.target;
        let anchorLink= targetElement.closest("a");
        let buttonElement = targetElement.closest("button");
        let position;
        let area_privada = "area_privada";

        if (anchorLink || buttonElement || targetElement.tagName === "A" || targetElement.tagName === "BUTTON") {

          let buttonUrl = targetElement.getAttribute("data-url") || targetElement.getAttribute("href") || add_address_buttons.querySelector("button")?.getAttribute("data-src") ||
          add_address_buttons.querySelector("a")?.getAttribute("href") || add_address_buttons.closest("a")?.getAttribute("href") || null;
        
          if (targetElement.tagName === "A") {
            elementType = "link";
            buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toLowerCase();
            buttonUrl = buttonUrl ? buttonUrl : add_address_buttons.getAttribute("href");
            actionType = 'click_on_link';
            position = targetElement?.dataset.position || null;
          } else if (targetElement.tagName === "BUTTON") {
            elementType = "button";
            buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toLowerCase();
            position = targetElement?.dataset.position || null;
            actionType = 'click_on_button'
          }


          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'select_content',
            'content_type': area_privada,
            'action_type': actionType,
            'element': elementType,
            'position': position,
            'link_text': buttonText,
            'url_destination': buttonUrl
          });
        }
      })
    });
   }
}

// edit address button 
{
   let edit_address_button = document.querySelectorAll('.js-edit-button');

   if (edit_address_button.length > 0) {
    edit_address_button.forEach(edit_button => {
      edit_button.addEventListener("click", (event) => {
        let targetElement = event.target;
        let anchorLink= targetElement.closest("a");
        let buttonElement = targetElement.closest("button");
        let position;
        let area_privada = "area_privada";
        if (anchorLink || buttonElement || targetElement.tagName === "A" || targetElement.tagName === "BUTTON") {

          let buttonUrl = targetElement.getAttribute("data-url") || targetElement.getAttribute("href") || edit_button.querySelector("button")?.getAttribute("data-src") ||
          edit_button.querySelector("a")?.getAttribute("href") || edit_button.closest("a")?.getAttribute("href") || null;
        
          if (targetElement.tagName === "A") {
            elementType = "link";
            buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toLowerCase();
            buttonUrl = buttonUrl ? buttonUrl : edit_button?.getAttribute("href");
            actionType = 'click_on_link';
            position = targetElement?.dataset.position || null;
          } else if (targetElement.tagName === "BUTTON") {
            elementType = "button";
            buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toLowerCase();
            position = targetElement?.dataset.position || null;
            actionType = 'click_on_button'
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'select_content',
            'content_type': area_privada,
            'action_type': actionType,
            'element': elementType,
            'position': position,
            'link_text': buttonText,
            'url_destination': buttonUrl
          });
        }
      })
    });
   }
}

// save address button
{
   document.querySelectorAll('.js-save-button').forEach(form => {
      form.addEventListener('submit', function (event) {
        const submitButton =
          event.submitter || form.querySelector('button[type="submit"]');
    
        if (!submitButton) return;
    
        let elementType = "button";
        let actionType = "click_on_button";
        let area_privada = "area_privada";
    
        let buttonText =
          submitButton.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() ||
          submitButton.textContent
            .trim()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, "_")
            .toLowerCase();

        let position = submitButton.dataset.position || null;
        let buttonUrl =
          submitButton.dataset.url ||
          submitButton.getAttribute("data-src") ||
          window.location.href;
    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "select_content",
          content_type: area_privada,
          action_type: actionType,
          element: elementType,
          position: position,
          link_text: buttonText,
          url_destination: buttonUrl
        });
      });
    });
}

// back button 
{
   let back_buttons = document.querySelectorAll('.js-back-button');

   if (back_buttons.length > 0) {
    back_buttons.forEach(backbutton => {
      backbutton.addEventListener("click", (event) => {
        let targetElement = event.target;
        let anchorLink= targetElement.closest("a");
        let buttonElement = targetElement.closest("button");
        let position;
        let area_privada = "area_privada";
        if (anchorLink || buttonElement || targetElement.tagName === "A" || targetElement.tagName === "BUTTON") {

          let buttonUrl = targetElement.getAttribute("data-url") || targetElement.getAttribute("href") || backbutton.querySelector("button")?.getAttribute("data-src") ||
          backbutton.querySelector("a")?.getAttribute("href") || backbutton.closest("a")?.getAttribute("href") || null;
        
          if (targetElement.tagName === "A") {
            elementType = "link";
            buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toLowerCase();
            buttonUrl = buttonUrl ? buttonUrl : backbutton.getAttribute("href");
            actionType = 'click_on_link';
            position = backbutton.dataset.position || null;
          } else if (targetElement.tagName === "BUTTON") {
            elementType = "button";
            buttonText = targetElement?.dataset.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase() || targetElement?.textContent.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toLowerCase();
            position = backbutton.dataset.position || null;
            actionType = 'click_on_button'
          }
          
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'select_content',
            'content_type': area_privada,
            'action_type': actionType,
            'element': elementType,
            'position': position,
            'link_text': buttonText,
            'url_destination': buttonUrl
          });
        }
      })
    });
   }
}

// see reward button

{
  let page = window.location.href;

  if (page.includes('/account')) {
    
    const intervalId = setInterval(() => {

    const widget = document.querySelector(
      ".gw-rd-loyalty-info-page-widget-placeholder"
    );

    if (!widget || !widget.shadowRoot) return;

    const rewardBtn = widget.shadowRoot.querySelector(".gw-rd-loyalty-info-page-widget__actions .gw-btn--mode-primary .gw-btn__label");    
    
    if (!rewardBtn) return;

    clearInterval(intervalId);

      rewardBtn.addEventListener('click', (event) => {        
        let elementType = 'button';
        let actionType = 'click_on_button';
        let area_privada = 'area_privada';
        const buttonText = rewardBtn.querySelector(".gw-text").innerText.trim();
        const buttontext = buttonText?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_").toLowerCase();
        let position = 'loyality_app_info';
        let buttonUrl = null;
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_content',
          content_type: area_privada,
          action_type: actionType,
          element: elementType,
          position: position,
          link_text: buttontext,
          url_destination: buttonUrl
        });

      });

    }, 500);

    setTimeout(() => clearInterval(intervalId), 10000);
  }
}